if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        if (isMobile) {
          activeMedia.scrollIntoView({
            behavior: 'instant',
            block: 'center',
            inline: 'nearest'
          });

          container.scrollLeft = 0;
        } else {
          activeMedia.scrollIntoView({
            behavior: 'instant',
            block: 'center',
            inline: 'center'
          });

          const isMobile = window.matchMedia('(max-width: 749px)').matches;
if (!isMobile) {
    container.scrollLeft = Math.max(
      0,
      (activeMedia.clientWidth - container.clientWidth) / 2
    );
} else {
    container.scrollLeft = 0;
}
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
